import { API_BASE_URL } from '@/config/api.config';

const isProductionHost = () => {
  try {
    if (typeof window === 'undefined') return true;
    const host = window.location.hostname;
    return host !== 'localhost' && host !== '127.0.0.1' && host !== '::1';
  } catch {
    return true;
  }
};

const computeHealthUrl = () => {
  try {
    const base = new URL(API_BASE_URL);
    return `${base.origin}/health`;
  } catch {
    return `${String(API_BASE_URL).replace(/\/$/, '')}/health`;
  }
};

const isLikelyCertOrCORS = (err) => {
  const message = String(err?.message || '').toLowerCase();
  return (
    message.includes('failed to fetch') ||
    message.includes('network error') ||
    message.includes('networkerror') ||
    message.includes('cors') ||
    message.includes('typeerror') ||
    message.includes('net::err_cert') ||
    message.includes('ssl')
  );
};

const openHealthOnce = (() => {
  const SES_KEY = 'network_health_opened_once';
  let opened = false;
  return () => {
    if (opened) return;
    try {
      if (sessionStorage.getItem(SES_KEY) === '1') return;
    } catch {}
    const healthUrl = computeHealthUrl();
    const popup = window.open(healthUrl, '_blank', 'noopener,noreferrer');
    opened = true;
    try { sessionStorage.setItem(SES_KEY, '1'); } catch {}
    if (!popup) {
      window.location.href = healthUrl;
    }
  };
})();

// Install earliest possible handler for unhandled rejections (fetch/axios network errors)
if (typeof window !== 'undefined' && isProductionHost()) {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event && (event.reason || event.detail || {});
    if (isLikelyCertOrCORS(reason)) {
      openHealthOnce();
    }
  });
}

